import { connect } from 'react-redux';

import { StoreState } from '../../reducers';
import NotesPage from '../../components/NotesPage';

const mapStateToProps = (state: StoreState) => {
	const { notes: { currentStatus, loadingStatus } } = state;
	return {
		notesStatus: currentStatus,
		loadingStatus,
	};
};

export default connect(mapStateToProps)(NotesPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/NotesPage/index.tsx